import { FC } from 'react';

import { Loader2 } from 'lucide-react';

import css from './AuthLoader.module.css';

export const AuthLoader: FC = () => (
  <div className={css.authLoaderContainer}>
    <div className={css.authLoader}>
      <Loader2 width={32} height={32} className="animate-spin" />

      <div className={css.authLoaderContent}>
        <p className={css.authLoaderContentTitle}>Checking authentication</p>

        <p className={css.authLoaderContentSubtitle}>Please wait while we verify your session...</p>
      </div>
    </div>
  </div>
);
